import React, { Component } from 'react';
import axios from 'axios';
import $ from "jquery";
import ConsultationOTP from '../commonFiles/ConsultationOTP';

class AddScheduleConsultation extends Component {
  constructor() {
    super();
    this.save_free_consulting = this.save_free_consulting_data.bind(this);
    this.validate_otp_input = this.validate_email_mobile.bind(this);
    this.state = {
      send_button : <button className="btn btn-primary w-100 py-3" type="button" onClick={this.save_free_consulting}>Add</button>,
      service_person_option:[],
      otp_inputs:'',
      token_id:'',
    };
  }

  save_free_consulting_data(){
    let cutThis         = this;
    var send_button     = <button className="btn btn-primary w-100 py-3" type="button">Add...</button>;
    cutThis.setState({send_button});
    $('label').removeClass('color_red');
    var first_name      = window.isNullAndUndef($('#first_name').val());
    var last_name       = window.isNullAndUndef($('#last_name').val());
    var email           = window.isNullAndUndef($('#email').val());
    var mobile_no       = window.isNullAndUndef($('#mobile_no').val());
    var subject_matter  = window.isNullAndUndef($('#subject_matter').val());
    var message         = window.isNullAndUndef($('#message').val());
    var web_token       = window.isNullAndUndef($('#web_token').val());
    var code            = window.isNullAndUndef($('#code').val());
    var email_validate  = window.validateEmail($('#email').val());
    var mobile_validate = window.validateMobile($('#mobile_no').val());
    var service_person = window.validateMobile($('#service_person').val());
    var schedule_date = window.validateMobile($('#schedule_date').val());
    var schedule_time = window.validateMobile($('#schedule_time').val());
    if(first_name && last_name && email && mobile_no && subject_matter && message && web_token && code && email_validate && mobile_validate && message.length<251 && service_person && schedule_date && schedule_time){
      var body = new FormData();
      body.append('first_name',first_name);
      body.append('last_name',last_name);
      body.append('email',email);
      body.append('mobile_no',mobile_no);
      body.append('subject_matter',subject_matter);
      body.append('message',message);
      body.append('code',code);
      body.append('web_token',web_token);
      body.append('service_person',service_person);
      body.append('schedule_date',schedule_date);
      body.append('schedule_time',schedule_time);
      body.append('function','add_schedule_consulting_data');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/ScheduleConsultationHomeForm_url.php";
      }else{
        url = "/php/ScheduleConsultationHomeForm_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          var msg = data['msg'];
          if(data['code']==1){
            $('#freeConsultation input').attr('readonly', 'readonly');
            $('#freeConsultation textarea').attr('readonly', 'readonly');
            $('#subject_matter option:not(:selected)').attr('disabled', true);
            var token_id = data['token_id'];
            cutThis.setState({token_id});
            var otp_inputs = <ConsultationOTP/>;
            cutThis.setState({otp_inputs});
            send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.validate_otp_input}>Verify Email & Mobile</button>;
            cutThis.setState({send_button});
            $('#error_msg').text(msg).removeClass('hide');
          }else {
            $('#error_msg').text(msg).removeClass('hide').addClass('color_red');
          }
       })
       .catch(function (error) {
           console.log(error);
       });
    }else{
      window.change_lable_color('first_name','last_name','email','mobile_no','subject_matter','message','code','service_person','schedule_date','schedule_time');
      if(mobile_validate){$('#mobile_no').next('label').removeClass('color_red');}else{$('#mobile_no').next('label').addClass('color_red');}
      if(email_validate){$('#mobile_no').next('label').removeClass('color_red');}else{$('#email').next('label').addClass('color_red');}
      send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.save_free_consulting}>Add</button>;
      cutThis.setState({send_button});
    }
    setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);
  }


  validate_email_mobile(){
    $('label').removeClass('color_red');
    let cutThis     = this;
    var send_button     = <button className="btn btn-primary w-100 py-3" type="button">Validating OTP...</button>;
    cutThis.setState({send_button});
    var token_id    = cutThis.state.token_id;
    var email_otp   = window.isNullAndUndef($('#email_otp').val());
    //var mobile_otp  = window.isNullAndUndef($('#mobile_otp').val());
    var web_token   = window.isNullAndUndef($('#web_token').val());
    //if(!isNaN(email_otp) && !isNaN(mobile_otp) && email_otp && mobile_otp && email_otp.length==6 && mobile_otp.length==6){
    if(!isNaN(email_otp) && email_otp && email_otp.length==6){
      var body = new FormData();
      body.append('token_id',token_id);
      body.append('email_otp',email_otp);
      //body.append('mobile_otp',mobile_otp);
      body.append('web_token',web_token);
      body.append('function','check_create_account_schedule_consulting_user');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/ScheduleConsultationHomeForm_url.php";
      }else{
        url = "/php/ScheduleConsultationHomeForm_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          var msg = data['msg'];
          if(data['code']==1){
            var send_button     = '';
            cutThis.setState({send_button});
            $('#error_msg').text(msg).removeClass('hide');
            setTimeout(function () {
              window.location.href = "/login";
            }, 20010);
          }else {
            $('#error_msg').text(msg).removeClass('hide').addClass('color_red');
          }
       })
       .catch(function (error) {
         console.log(error);
       });
    }else{
      $('#email_otp').next('label').addClass('color_red');
      //$('#mobile_otp').next('label').addClass('color_red');
      send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.validate_otp_input}>Verify Email & Mobile</button>;
      cutThis.setState({send_button});
    }
    setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);
  }

  get_service_person_list(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','service_person_list');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
     }else{
       url = "/php/admin_free_consultation_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var service_person = res.data;
        console.log(service_person);
        var service_person_option = [];
        for(var i=0; i<service_person.length; i++){
          var full_name = service_person[i]['first_name']+" "+service_person[i]['last_name'];
          var id = service_person[i]['id']
          service_person_option.push(<option value={id}>{full_name}</option>);
        }
        cutThis.setState({service_person_option});
      })
      .catch(function (error) {
          console.log(error);
      });

  }

  componentDidMount() {
   this.get_service_person_list();
  }


  render() {
    return (
      <div className="modal fade" id="myModal" role="dialog">
        <div className="modal-dialog popup_view_width">
          <div className="modal-content">
            <div className="modal-header">
            <h4 className="modal-title" id="page_titlte">Add Consultation</h4>
              <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
            </div>
            <div className="modal-body">


            <div className="">
            <div className="col-md-12">
                <div className="wow fadeInUp" data-wow-delay="0.5s">
                <form action="" method="post">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="form-floating">
                                <select class="form-control form-select" id="service_person" name="service_person">
                                <option value="">Select a Service Person</option>
                                {this.state.service_person_option}
                            </select>
                            <label for="name">Service Person</label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-floating">
                                <input type="text" className="form-control" id="subject_matter" name="subject_matter" placeholder="Subject Matter" maxlength="50"/>
                                <label for="email">Subject Matter</label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-floating">
                                <input type="date" className="form-control" id="schedule_date" name="schedule_date" placeholder="Date"/>
                                <label for="email">Date</label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-floating">
                                <input type="time" className="form-control" id="schedule_time" name="schedule_time" placeholder="Time"/>
                                <label for="email">Time</label>
                            </div>
                        </div>


                        <div className="col-12">
                            <div className="form-floating">
                                <textarea className="form-control textarea-height" placeholder="Leave a message here" id="message" name="message" maxlength="250"></textarea>
                                <label for="message">Message</label>
                            </div>
                        </div>


                        {this.state.otp_inputs}

                        <div className="col-md-12">
                        <p className="hide" id="error_msg"></p>
                        {this.state.send_button}
                        </div>
                    </div>
                </form>
                </div>
            </div>
            </div>


            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddScheduleConsultation;
